import { useState } from "react";
import { DndContext, closestCenter, DragOverlay } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { useDefaultSensors } from "../SortUtils";

const DragDropSortableList = ({
  items = [],
  onReorder,
  renderItem,
  itemKeyExtractor = (item) => item.id,
  emptyMessage = "No items yet.",
  disabled = false,
  className = "",
}) => {
  const sensors = useDefaultSensors();
  const [activeId, setActiveId] = useState(null);

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) {
      setActiveId(null);
      return;
    }

    const oldIdx = items.findIndex((item) => itemKeyExtractor(item) === active.id);
    const newIdx = items.findIndex((item) => itemKeyExtractor(item) === over.id);

    if (oldIdx === -1 || newIdx === -1) {
      setActiveId(null);
      return;
    }

    const reordered = [...items];
    const [moved] = reordered.splice(oldIdx, 1);
    reordered.splice(newIdx, 0, moved);

    onReorder(reordered);
    setActiveId(null);
  };

  if (items.length === 0) {
    return <div className="uk-text-meta uk-text-center uk-padding-small">{emptyMessage}</div>;
  }

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragStart={(e) => !disabled && setActiveId(e.active?.id || null)}
      onDragCancel={() => setActiveId(null)}
      onDragEnd={handleDragEnd}
    >
      <SortableContext
        items={items.map(itemKeyExtractor)}
        strategy={verticalListSortingStrategy}
        disabled={disabled}
      >
        <ul className={`uk-list ${className}`}>
          {items.map((item, index) => (
            <li key={itemKeyExtractor(item)}>
              {renderItem(item, index)}
            </li>
          ))}
        </ul>
      </SortableContext>

      {activeId && !disabled ? <DragOverlay /> : null}
    </DndContext>
  );
};

export default DragDropSortableList;
